export const SET_DANH_SACH_TIEN_TE = 'SET_DANH_SACH_TIEN_TE'
export const SET_EDIT_TIEN_TE = 'SET_EDIT_TIEN_TE'

export const LAY_DANH_SACH_TIEN_TE_SAGA = 'LAY_DANH_SACH_TIEN_TE_SAGA'

export const CHINH_SUA_TI_GIA_SAGA = 'CHINH_SUA_TI_GIA_SAGA'